"use client";

import dynamic from "next/dynamic";

// Shared client-side async boundary for the Sade Sati phase timeline studio
// (22.7 KB phase module, measured duplicated across the en and hi sade-sati
// routes, 2026-08-22). Static imports from the two server pages gave each
// route chunk group a full copy; this ONE client module puts the studio in a
// single async chunk both routes load. Default ssr keeps the phase copy's
// crawlable SSR HTML intact.
const SadeSatiTimelineStudioLazy = dynamic(() => import("./SadeSatiTimelineStudio"));

export default SadeSatiTimelineStudioLazy;
